import { render, staticRenderFns } from "./wettmpInfoModule2.vue?vue&type=template&id=5475d04c&scoped=true"
import script from "./wettmpInfoModule2.vue?vue&type=script&lang=js"
export * from "./wettmpInfoModule2.vue?vue&type=script&lang=js"
import style0 from "./wettmpInfoModule2.vue?vue&type=style&index=0&id=5475d04c&prod&lang=scss&scoped=true"
import style1 from "./wettmpInfoModule2.vue?vue&type=style&index=1&id=5475d04c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5475d04c",
  null
  
)

export default component.exports